import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { paymentAPI } from 'redux/paymentAPI';
import { FetchingState } from '@payer-admin-ui/components-v2/src/types/state';
import { patch } from '@payer-admin-ui/components-v2/src/functions/lodashExtensions';

export type ExportToPyramidProps = {
  creationDateStart: string;
  creationDateEnd: string;
  disabled?: boolean;
};

export const exportToPyramid = createAsyncThunk<Promise<string>, ExportToPyramidProps>(
  'payments/download/exportToPyramid',
  async ({ creationDateStart, creationDateEnd }) => {
    return await paymentAPI.exportToPyramid({ creationDateStart, creationDateEnd });
  },
);

const paymentDownloadSlice = createSlice({
  name: 'payments/download',
  initialState: {} as FetchingState,
  reducers: {
    resetError: state => {
      state.error = undefined;
    },
  },
  extraReducers: builder => {
    builder.addCase(exportToPyramid.pending, (state, { meta: { arg } }) => {
      patch(state, { isFetching: true, success: undefined, error: undefined });
    });
    builder.addCase(exportToPyramid.fulfilled, (state, { meta: { arg } }) => {
      patch(state, { isFetching: false, success: true, error: undefined });
    });
    builder.addCase(exportToPyramid.rejected, (state, { meta: { arg }, error }) => {
      patch(state, { isFetching: false, success: false, error });
    });
  },
});

export const {
  actions: { resetError: resetDownloadError },
  reducer: paymentDownloadReducer,
} = paymentDownloadSlice;
